const customIconify = {
  install: (): void => {
  }
}

export default customIconify
